import { EVIDENCE_DESCRIPTIONS_ROUTES } from '../../modules/evidence-descriptions/constants/routes';
import { FILTERS } from './evidence-descriptions-filters';

export const EVIDENCE_DESCRIPTIONS_LISTING_FILTERS = {
  path: EVIDENCE_DESCRIPTIONS_ROUTES.EVIDENCE_DESCRIPTIONS_LIST.path,
  filters: FILTERS,
};
